/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_MANAGE_LEAD,
  ADD_MANAGE_LEAD,
  UPDATE_MANAGE_LEAD,
  DELETE_MANAGE_LEAD,
  ADD_LEAD_STATUS,
  LOAD_LEAD_RECORDS_META_DATA,
  LOAD_CUSTOM_FIELD,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadManageLead,
  loadManageLeadError,
  loadManageLeadSuccess,
  addManageLeadSuccess,
  addManageLeadError,
  updateManageLeadSuccess,
  updateManageLeadError,
  deleteManageLeadSuccess,
  deleteManageLeadError,
  addLeadStatusSuccess,
  addLeadStatusError,
  loadLeadRecordsMetaDataSuccess,
  loadLeadRecordsMetaDataError,
  loadCustomFields,
  loadCustomFieldsSuccess,
  loadCustomFieldsError,
} from "./actions"

import {
  loadManageLeadDetails,
  loadRecordsMetaData,
  addManageLeadDetails,
  updateManageLeadDetails,
  deleteManageLeadDetails,
  leadStatusDetails,
  loadLeadRecordsMetaDataDetails,
  loadCustomFieldsDetails,
} from "./remotes"

function* loadManageLeadSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_MANAGE_LEAD),
    })

    const { explicitLoad } = load

    const { searchvalue } = explicitLoad || {}
    yield put(loadManageLead(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadManageLeadDetails, searchvalue)
        console.log("api result is", result)

        if (result) {
          yield put(loadManageLeadSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadManageLeadSuccess([]))
          yield put(loadManageLeadError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadManageLeadSuccess([]))
        yield put(
          loadManageLeadError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadCustomFieldsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CUSTOM_FIELD),
    })

    const { explicitLoad } = load

    const { customFields } = explicitLoad || {}
    yield put(loadCustomFields(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCustomFieldsDetails, customFields)
        console.log("api result is", result)

        if (result) {
          yield put(loadCustomFieldsSuccess(result.data))
          console.log(result.data)
        } else {
          yield put(loadCustomFieldsSuccess([]))
          yield put(loadCustomFieldsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadCustomFieldsSuccess([]))
        yield put(
          loadCustomFieldsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const company = yield call(loadRecordsMetaData, "company", "post")
      const branch = yield call(loadRecordsMetaData, "branch", "post")
      const event = yield call(loadRecordsMetaData, "event", "post")
      // const budget = yield call(loadRecordsMetaData, "budget_color", "post")
      const employee = yield call(
        loadRecordsMetaData,
        "employee_dropdown_list",
        "post"
      )
      const payload = { mode: "sales" }
      const processStatus = yield call(
        loadRecordsMetaData,
        "process_status",
        "post",
        payload
      )
      const leadService = yield call(
        loadRecordsMetaData,
        "lead_service",
        "post"
      )
      const priority = yield call(loadRecordsMetaData, "priority", "post")
      const source = yield call(loadRecordsMetaData, "source", "post")

      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p.processStatusId,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
        eventOptions:
          (event &&
            event.data &&
            event.data.length > 0 &&
            event.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventName,
                    value: c._id,
                    eventCode: c.eventCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],

        employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data.map((c) =>
              Object.assign(
                {},
                {
                  label: c.empCode.concat(" - ", c.name),
                  value: c._id,
                  name: c.name,
                }
              )
            )) ||
          [],
        serviceOptions:
          (leadService &&
            leadService.data &&
            leadService.data.length > 0 &&
            leadService.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: e.service,
                    type: e.type,
                    value: e._id,
                    companyId: e.companyId,
                  }
                )
              )) ||
          [],
        // budgetOptions:
        //   (budget &&
        //     budget.data &&
        //     budget.data.length > 0 &&
        //     budget.data
        //       .filter((_) => _.status === 1)
        //       .map((e) =>
        //         Object.assign(
        //           {},
        //           {
        //             label: `${e.budgetFrom} - ${e.budgetTo}`,
        //             value: e._id,
        //           }
        //         )
        //       )) ||
        //   [],
        priorityOptions:
          (priority &&
            priority.data &&
            priority.data.length > 0 &&
            priority.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: e.priority,
                    colorCode: e.colorCode,
                    value: e._id,
                  }
                )
              )) ||
          [],
        sourceOptions:
          (source &&
            source.data &&
            source.data.length > 0 &&
            source.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.sourceName, value: c._id })
              )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
function* loadLeadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_LEAD_RECORDS_META_DATA),
    })

    try {
      // const source = yield call(
      //   loadLeadRecordsMetaDataDetails,
      //   "source",
      //   "post"
      // )
      const subSource = yield call(
        loadLeadRecordsMetaDataDetails,
        "sub_source",
        "post"
      )
      const clientProfile = yield call(
        loadLeadRecordsMetaDataDetails,
        "client_profile",
        "post"
      )
      const company = yield call(loadRecordsMetaData, "company", "post")

      console.log(subSource, "my subsource")
      // const priorityStatus = yield call(loadLeadRecordsMetaDataDetails, "priority", "post")
      // const customField = yield call(
      //   loadLeadRecordsMetaDataDetails,
      //   "custom_field",
      //   "post"
      // )
      const country = yield call(
        loadLeadRecordsMetaDataDetails,
        "country",
        "post"
      )
      const state = yield call(loadLeadRecordsMetaDataDetails, "state", "post")
      const city = yield call(loadLeadRecordsMetaDataDetails, "city", "post")

      let leadRecordsMetaData = {
        // sourceOptions:
        //   (source &&
        //     source.data &&
        //     source.data.length > 0 &&
        //     source.data
        //       .filter((_) => _.status === 1)
        //       .map((c) =>
        //         Object.assign({}, { label: c.sourceName, value: c._id })
        //       )) ||
        //   [],
        subSourceOptions:
          (subSource &&
            subSource.data &&
            subSource.data.length > 0 &&
            subSource.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.subSourceName, value: c._id, sourceId: c.sourceId }
                )
              )) ||
          [],
        countryOptions:
          (country &&
            country.data &&
            country.data.length > 0 &&
            country.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.name,
                    value: c._id,
                    states: c.states,
                    shortName: c.shortName,
                  }
                )
              )) ||
          [],
        stateOptions:
          (state &&
            state.data &&
            state.data.length > 0 &&
            state.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, countryId: c.countryId }
                )
              )) ||
          [],
        cityOptions:
          (city &&
            city.data &&
            city.data.length > 0 &&
            city.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.name,
                    value: c._id,
                    sourceId: c.sourceId,
                    stateId: c.stateId,
                  }
                )
              )) ||
          [],
        clientProfileOptions:
          (clientProfile &&
            clientProfile.data &&
            clientProfile.data.length > 0 &&
            clientProfile.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.clientProfile, value: c._id })
              )) ||
          [],
        // customFieldOptions:
        //   (customField &&
        //     customField.data &&
        //     customField.data.length > 0 &&
        //     customField.data.filter((_) => _.status === 1)) ||
        //   [],
        companyTableOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data.filter((_) => _.status === 1)) ||
          [],
      }

      yield put(loadLeadRecordsMetaDataSuccess(leadRecordsMetaData))
    } catch (error) {
      yield put(
        loadLeadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* addManageLeadSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_MANAGE_LEAD),
    })
    const { leadDetails } = add || {}
    if (add) {
      try {
        yield call(addManageLeadDetails, leadDetails)
        yield put(
          addManageLeadSuccess(leadDetails, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          addManageLeadError(
            (error && error.response && error.response.message) ||
              (error && error.response && error.response.message) ||
              (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateManageLeadSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_MANAGE_LEAD),
    })
    const { leadDetails } = add || {}
    if (add) {
      try {
        yield call(updateManageLeadDetails, leadDetails)
        yield put(
          updateManageLeadSuccess(leadDetails, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          updateManageLeadError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteManageLeadSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(DELETE_MANAGE_LEAD),
    })
    const { leadDetails } = add || {}
    if (add) {
      try {
        yield call(deleteManageLeadDetails, leadDetails)
        yield put(
          deleteManageLeadSuccess(leadDetails, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          deleteManageLeadError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* addLeadStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_LEAD_STATUS),
    })
    const { leadStatus } = add || {}
    if (add) {
      try {
        yield call(leadStatusDetails, leadStatus)
        yield put(
          addLeadStatusSuccess(leadStatus, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          addLeadStatusError(
            (error && error.response && error.response.message) ||
              (error && error.response && error.response.message) ||
              (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadLeadRecordsMetaDataSaga(),
    loadManageLeadSaga(),
    addManageLeadSaga(),
    updateManageLeadSaga(),
    deleteManageLeadSaga(),
    addLeadStatusSaga(),
    loadCustomFieldsSaga(),
  ])
}
